import React, { useEffect, useState } from 'react'
import { Table } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { getMasterCountryDetail } from '../../Redux/action/MasterAction';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useFormik } from 'formik';
import { getCustomerList, getCustomerRegData } from '../../Redux/action/Admin/CustomerAction';
import Contract from './Contract';
import ApprovalDisapprovalModal from './ApprovalDisapprovalModal';
import { Tooltip } from 'antd';
import { adminMainUrl } from '../../Config';
import Beatloader from '../../Common/Loaders/Beatloader';



const AllCustomerList = ({ accessedPermission, viewDownline }) => {

    const { b64id } = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [showLoader, setshowLoader] = useState(false);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);

    const [customer_id, setCustomer_id] = useState("");
    const [customer_name, setCustomer_name] = useState("");


    useEffect(() => {
        if (token && user_id) {
            if (b64id) {
                let get_customer_id = atob(b64id);
                if (get_customer_id) {
                    dispatch(getCustomerList(token, user_id, queryParams.get("page") ?? 1, queryParams.get('search'), get_customer_id));
                }
            } else {
                dispatch(getCustomerList(token, user_id, queryParams.get("page") ?? 1, queryParams.get('search')));
            }

        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search, b64id]);


    const refresh = () => {
        if (token && user_id) {
            if (b64id) {
                let get_customer_id = atob(b64id);
                if (get_customer_id) {
                    dispatch(getCustomerList(token, user_id, queryParams.get("page") ?? 1, queryParams.get('search'), get_customer_id));
                }
            } else {

                dispatch(getCustomerList(token, user_id, queryParams.get("page") ?? 1, queryParams.get('search')));
            }
            // dispatch(getCustomerList(token, user_id, queryParams.get("page") ?? 1, queryParams.get('search')));
        }
    }

    let {
        loadingCustomerListApi,
        CustomerListError,
        CustomerList,
        CustomerTotalPage,
        CustomerCurrentPage,
        CustomerTotalData,
        loadingCustomerRegDataApi,
        CustomerRegDataError,
        CustomerRegData,
        CustomerParentDetail
    } = useSelector(state => state?.CustomerReducer);


    const [dataSource, setDataSource] = useState([]);
    const columns = [
        {
            title: 'S. No.',
            dataIndex: 'S. No.',
            key: 'S. No.',
        },
        {
            title: 'Email',
            dataIndex: 'Email',
            key: 'Email',
        },
        {
            title: 'Username',
            dataIndex: 'Username',
            key: 'Username',
        },
        {
            title: 'Mobile',
            dataIndex: 'Mobile',
            key: 'Mobile',
        },
        {
            title: 'Customer Type',
            dataIndex: 'Customer Type',
            key: 'Customer Type',
        },
        {
            title: 'Customer Name',
            dataIndex: 'Customer Name',
            key: 'Customer Name',
        },
        // {
        //     title: 'Contract',
        //     dataIndex: 'Contract',
        //     key: 'Contract',
        // },
        {
            title: 'Documents',
            dataIndex: 'Documents',
            key: 'Documents',
        },
        { title: "Profile Completed", dataIndex: "Profile Completed", key: "Profile Completed" },
        { title: "Sub Agent", dataIndex: "sub_agent", key: "sub_agent" },
        { title: "Entity", dataIndex: "entity", key: "entity" },
        { title: "Created By", dataIndex: "created_by", key: "created_by" },
        { title: "Job Order/Quotation Count", dataIndex: "jo/q", key: "jo/q" },
        { title: "Approval Status", dataIndex: "Approval", key: "Approval" },

        { title: "Status", dataIndex: "Status", key: "Status" },
        {
            title: 'Action',
            dataIndex: 'Action',
            key: 'Action',
        },

    ];


    const handleChangeStatus = async (id) => {
        if (!id) { toast.error("Could not found id."); return; };
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "Do you want to change the status?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, change it!',
                cancelButtonText: 'No, cancel!',
            });


            if (result.isConfirmed) {
                axios.post(`${adminMainUrl}/api/master/country/status`, { id: id }, { headers: { "auth-token": token, "user_id": user_id } })
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            refresh();
                        } else {
                            toast.success(response.data.msg);
                        }
                    }).catch(error => {
                        console.log(error);
                        toast.error(error.message);
                    })
            }
        } catch (error) {
            console.error("Error changing status:", error);
            toast.error("An error occurred while changing the status.");
        }
    };

    const handleChange = async (id) => {
        try {
            const response = await fetch(
                `${adminMainUrl}/api/customer/status-change`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
                    },
                    body: JSON.stringify({ id: id.toString() }),
                }
            );

            const data = await response.json();

            if (response.ok) {
                refresh();
                toast.success(data?.msg);
            } else {
                toast.error(data?.msg);
            }
        } catch (error) {
            console.error("Network error:", error);
        }
    };

    const handleApproval = async (id, approval) => {
        try {
            const response = await fetch(
                `${adminMainUrl}/api/customer/approval`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
                    },
                    body: JSON.stringify({ customer_id: id.toString(), approval }),
                }
            );

            const data = await response.json();

            if (response.ok) {
                refresh();
                toast.success(data?.msg);
            } else {
                toast.error(data?.msg);
            }
        } catch (error) {
            console.error("Network error:", error);
        }
    };


    const handleDownloadhandleDownload = async (id) => {
        try {
            const response = await fetch(
                `${adminMainUrl}/api/customer/download-profile?customer_id=${id}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": Cookies.get("token"), 
                        'user_id': Cookies.get('flexichain_user_id')
                    },
                   
                }
            );

            const data = await response.json();

            if (response.ok) {
                refresh();
                toast.success(data?.msg);
            } else {
                toast.error(data?.msg);
            }
        } catch (error) {
            console.error("Network error:", error);
        }
    };

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);
    const handleDownload = (id) => {
        if (!id) { toast.error("MAWB not found"); return; }
        // console.log("hi hello")
        setDisableDownloadPDF(true);
        let config = { 
            headers: {
                "Content-Type": "application/json",
                "auth-token": Cookies.get("token"), 
                'user_id': Cookies.get('flexichain_user_id')
            },
             responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/customer/download-profile?customer_id=${id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `customer-profile.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }


    const [approvalshow, setApprovalShow] = useState(false);
    const handleApprovalClose = () => setApprovalShow(false);
    const handleApprovalShow = (id, name) => {
        setCustomer_id(id);
        setCustomer_name(name)
        setApprovalShow(true);
    };


    const [contractshow, setContractShow] = useState(false);
    const handleContractClose = () => setContractShow(false);
    const handleContractShow = (id) => {
        setContractShow(true);
        dispatch(getCustomerRegData(id));
    };



    useEffect(() => {
        if (loadingCustomerListApi) {
            setshowLoader(true);
        } else {
            setshowLoader(false);
        }

        if (CustomerList) {
            let arr = [];
            CustomerList.map((customer, index) => {
                arr.push({
                    "S. No.": index + 1,
                    "Customer Type": customer.customerType,
                    "Email": customer?.email,
                    "Username": customer?.username,
                    "Mobile": customer?.mobile,
                    "Customer Name": customer?.name,
                    "Documents": (accessedPermission.includes("customer_view_document") ?
                        <Link to={`/flexichain/customer-document-list/${btoa(customer.id)}`}
                            className="dropdown-item edit-popup"
                        ><i className="ti ti-eye text-blue"></i></Link> : <i>Unauthorized</i>),
                    "Profile Completed": customer.profileCompleted ? 'Yes' : 'No',
                    "sub_agent": customer.has_sub_agent ? <>{customer.agent_name ?? "-"}</> : <i>No Sub Agent</i>,
                    "created_by": customer.created_by_user ?? "-",
                    "entity": customer.entity_type ? Array.isArray(JSON.parse(customer.entity_type)) ? JSON.parse(customer.entity_type).map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(', ') : "-" : "-",
                    "jo/q": <>
                        {
                            (customer.quotation_count && customer.job_order_count) ?
                                <span className={customer.job_order_count == customer.quotation_count ? 'text-success' : 'text-danger'}><b> {customer?.job_order_count} / {customer?.quotation_count}</b></span>
                                :
                                (customer.quotation_count && !customer.job_order_count) ?
                                    <span className={'text-danger'}><b> {customer?.job_order_count ?? 0} / {customer?.quotation_count ?? 0}</b></span>
                                    :
                                    (!customer.quotation_count && customer.job_order_count) ?
                                        <span className={'text-danger'}><b> {customer?.job_order_count ?? 0} / {customer?.quotation_count ?? 0}</b></span>
                                        :
                                        <span> {customer?.job_order_count ?? 0} / {customer?.quotation_count ?? 0}</span>
                        }
                    </>,
                    "Approval": customer.profileCompleted ? customer?.approval : <i>Profile Incomplete</i>,
                    "Status":
                        <>
                            <span id={`flexSwitchCheckChecked-${index}`}
                                onClick={() => handleChange(customer.id)} className={`cursor-pointer ${customer.status === true ? "badge badge-pill badge-status bg-success" : "badge badge-pill badge-status bg-danger"}  `}>{customer.status === true ? "Active" : "Inactive"}</span>


                        </>
                    ,
                    "Action": (
                        <div className="dropdown table-action" key={customer.id}>
                            <Link
                                to="#"
                                className="action-icon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                            >
                                <i className="fa fa-ellipsis-v"></i>
                            </Link>
                            <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{
                                    position: "absolute",
                                    inset: "0px auto auto 0px",
                                    margin: "0px",
                                    transform: "translate3d(-99.3333px, 35.3333px, 0px)",
                                }}
                                data-popper-placement="bottom-start"
                            >
                                {accessedPermission.includes("customer_view") && <Link to={`/flexichain/customer-view/${btoa(customer.id)}`}
                                    className="dropdown-item edit-popup"

                                >
                                    <i className="fa-solid fa-eye text-blue me-1"></i> View
                                </Link>}
                                {accessedPermission.includes("customer_edit") && accessedPermission.includes("customer_edit") && <Link to={`/flexichain/organization/edit/${btoa(customer.id)}`}
                                    className="dropdown-item edit-popup"

                                >
                                    <i className="ti ti-edit text-blue"></i> Edit
                                </Link>}
                                {accessedPermission.includes("customer_view_quotation") && <Link to={`/flexichain/customer/quotations/${btoa(customer.id)}`}
                                    className="dropdown-item edit-popup"
                                >
                                    <i className="fa-solid fa-vault text-blue"></i> View Quotations
                                </Link>}
                                {accessedPermission.includes("customer_profile_approval") && customer.profileCompleted && customer?.approval == "PENDING" && <span className="dropdown-item edit-popup"
                                    onClick={() => handleApprovalShow(customer.id, customer.customerType == 'Individual/Proprietary firm' ? customer.individualName : customer.name)}
                                >
                                    <i className="fa-regular fa-thumbs-up text-blue me-1"></i> Approval
                                </span>}
                                {accessedPermission.includes("customer_contract_list") && (customer.profileCompleted && customer?.approval == "APPROVED") && <span className="dropdown-item edit-popup"
                                    onClick={() => navigate(`/flexichain/customer-contract/${btoa(customer.id)}`)}
                                >
                                    <i className="fa-solid fa-file-contract text-blue me-1"></i> View Contract
                                </span>}

                                {customer.entity_type && Array.isArray(JSON.parse(customer.entity_type)) && JSON.parse(customer.entity_type).includes("agent") && <span className="dropdown-item edit-popup"
                                    onClick={() => {
                                        navigate(`/flexichain/downline-customer-list/${btoa(customer.id)}`)
                                    }}
                                >
                                    <i className="fa-solid fa-user text-blue me-1"></i> Customers
                                </span>}
                                {/* {accessedPermission.includes("ff_ae_direct_shipment_download") && */}
                                 <button className="dropdown-item" onClick={() => { handleDownload(customer.id
                                 ) }} disabled={disableDownloadPDF} >
                                    {disableDownloadPDF ? <><i className="fas fa-spinner fa-spin me-1"></i> Downloading...</> : <><i className="fa-solid fa-download text-blue-light me-1"></i> Download Profile</>}
                                </button>
                                {/* } */}
                            </div>
                        </div>
                    ),
                })
            });
            setDataSource(arr);
        }
    }, [loadingCustomerListApi, CustomerList]);


    useEffect(() => {
        if (CustomerCurrentPage) {
            setCurrentPage(CustomerCurrentPage);
        }


        if (CustomerTotalPage) {
            setTotalPages(CustomerTotalPage)
        }
    }, [
        CustomerCurrentPage,
        CustomerTotalPage,
        CustomerTotalData
    ]);




    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };


    //search functionality
    let initialValues = {
        search_text: "",
    };
    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            const search_text = values.search_text.trim();
            const currentUrl = new URL(window.location.href);


            if (search_text) {
                currentUrl.searchParams.set("search", search_text);
            } else {
                currentUrl.searchParams.delete("search");
            }
            navigate(`${currentUrl.pathname}${currentUrl.search}`);
        }
    });


    useEffect(() => {
        if (queryParams.get("search")) {
            formik.setFieldValue("search_text", queryParams.get("search"))
        }
    }, [queryParams.get("search")]);


    const handleReset = () => {
        // formik.setFieldValue("search_by","");
        let resetPath = location.pathname;
        // console.log(resetPath);
        formik.resetForm();
        navigate(resetPath);
    };

    const [showParentDetail, setShowParentDetail] = useState(false);
    const [parentName, setParentName] = useState("");
    const [parentEmail, setParentEmail] = useState("");
    const [parentMobile, setParentMobile] = useState("");
    useEffect(() => {
        // console.log("CustomerParentDetail",CustomerParentDetail);
        if (CustomerParentDetail) {
            setShowParentDetail(true);
            setParentName(CustomerParentDetail.name);
            setParentEmail(CustomerParentDetail.email);
            setParentMobile(CustomerParentDetail.mobile);
        } else {
            setShowParentDetail(false);
            setParentName("");
            setParentEmail("");
            setParentMobile("");
        }
    }, [CustomerParentDetail])




    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">Customer <span className="count-title">{CustomerTotalData ?? "0"}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {viewDownline && showParentDetail &&
                        <>
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="form-label-cus">Customer Name:</label>
                                            <input type="text"
                                                className='form-control form-control-sm'
                                                value={parentName}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label-cus">Customer Email:</label>
                                            <input type="text"
                                                className='form-control form-control-sm'
                                                value={parentEmail}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label-cus">Customer Mobile:</label>
                                            <input type="text"
                                                className='form-control form-control-sm'
                                                value={parentMobile}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    <div className="card">
                        <div className="card-header py-2">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row align-items-center">
                                    <div className="col-sm-4">
                                        <div className="icon-form mb-3 mb-sm-0">
                                            <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Search "
                                                name='search_text'
                                                value={formik.values.search_text}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                            <button type='submit' className="btn btn-primary me-2">
                                                Search
                                            </button>
                                            <button type='button' className="btn btn-light me-2" onClick={() => { handleReset() }}>
                                                Reset
                                            </button>
                                            {
                                                accessedPermission.includes("customer_add") &&
                                                <Tooltip placement="top" title="Add Organization">
                                                    <div
                                                        className="btn btn-primary cursor-pointer"
                                                        onClick={() => { navigate(b64id ? `/flexichain/organization/add?sa=${b64id}` : "/flexichain/organization/add") }}
                                                    >
                                                        <i className="ti ti-square-rounded-plus " />
                                                    </div>
                                                </Tooltip>
                                            }
                                            {
                                                accessedPermission.includes("bulk_export") &&
                                                <Tooltip placement="top" title="Export Organization">
                                                    <Link
                                                        className="btn btn-primary cursor-pointer ms-2"
                                                        to={`${adminMainUrl}/api/customer/bulk-export`}
                                                    >
                                                        <i className="fa-solid fa-file-export " />
                                                    </Link>
                                                </Tooltip>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>


                        <div className="card-body">
                            {
                                showLoader ?
                                    <>
                                        <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                            <Beatloader />
                                        </div>
                                    </> :
                                    <>
                                        <div className="table-responsive custom-table">
                                            <Table className="table datanew dataTable no-footer" pagination={false}
                                                dataSource={dataSource} columns={columns} />
                                        </div>
                                        <div className="row align-items-center">
                                            {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div> :
                                                null
                                            }
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Contract show={contractshow}
                handleClose={handleContractClose}
                onSuccess={refresh}
                loadingCustomerRegDataApi={loadingCustomerRegDataApi}
                CustomerRegDataError={CustomerRegDataError}
                CustomerRegData={CustomerRegData} />

            <ApprovalDisapprovalModal show={approvalshow}
                handleClose={handleApprovalClose}
                customer_id={customer_id}
                customer_name={customer_name}
                refresh={refresh} />

        </>
    )
}


export default AllCustomerList